const state = {
 reload_company_referrals: false,
};

const actions = {};

const mutations = {
 RELOAD_COMPANY_REFERRALS(state, payload) {
  state.reload_company_referrals = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
